import { defineComponent as v, h as e } from "vue";
import { useCalendarProps as f, useCalendar as k } from "./ghl-ui.es1342.js";
import $ from "./ghl-ui.es1343.js";
import y from "./ghl-ui.es182.js";
import C from "./ghl-ui.es373.js";
import { resolveSlot as o } from "./ghl-ui.es860.js";
import D from "./ghl-ui.es1069.js";
import _ from "./ghl-ui.es1067.js";
import P from "./ghl-ui.es1066.js";
import b from "./ghl-ui.es1068.js";
import p, { XButton as O } from "./ghl-ui.es253.js";
import x from "./ghl-ui.es1147.js";
const I = v({
  name: "DateTimePanel",
  props: f,
  setup(s) {
    return k(s, "datetime");
  },
  render() {
    var s, d, c, h;
    const {
      mergedClsPrefix: t,
      mergedTheme: i,
      shortcuts: n,
      timePickerProps: m,
      onRender: u,
      $slots: r
    } = this;
    return u == null || u(), e("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t}-date-panel`, `${t}-date-panel--datetime`, !this.panel && `${t}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, e("div", {
      class: `${t}-date-panel-header`
    }, e(y, {
      value: this.dateInputValue,
      theme: i.peers.Input,
      themeOverrides: i.peerOverrides.Input,
      stateful: !1,
      size: this.timePickerSize,
      class: `${t}-date-panel-date-input`,
      textDecoration: this.isDateInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleDateInputBlur,
      onUpdateValue: this.handleDateInput
    }), e(C, Object.assign({
      size: this.timePickerSize,
      placeholder: this.locale.selectTime,
      format: this.timeFormat
    }, Array.isArray(m) ? void 0 : m, {
      showIcon: !1,
      to: !1,
      theme: i.peers.TimePicker,
      themeOverrides: i.peerOverrides.TimePicker,
      value: Array.isArray(this.value) ? null : this.value,
      isHourDisabled: this.isHourDisabled,
      isMinuteDisabled: this.isMinuteDisabled,
      isSecondDisabled: this.isSecondDisabled,
      onUpdateValue: this.handleTimePickerChange,
      stateful: !1
    }))), e("div", {
      class: `${t}-date-panel-calendar`
    }, e("div", {
      class: `${t}-date-panel-month`
    }, e("div", {
      class: `${t}-date-panel-month__fast-prev`,
      onClick: this.prevYear
    }, o(r["prev-year"], () => [e(D, null)])), e("div", {
      class: `${t}-date-panel-month__prev`,
      onClick: this.prevMonth
    }, o(r["prev-month"], () => [e(_, null)])), e($, {
      monthBeforeYear: this.locale.monthBeforeYear,
      value: this.calendarValue,
      onUpdateValue: this.onUpdateCalendarValue,
      mergedClsPrefix: t,
      calendarMonth: this.calendarMonth,
      calendarYear: this.calendarYear
    }), e("div", {
      class: `${t}-date-panel-month__next`,
      onClick: this.nextMonth
    }, o(r["next-month"], () => [e(P, null)])), e("div", {
      class: `${t}-date-panel-month__fast-next`,
      onClick: this.nextYear
    }, o(r["next-year"], () => [e(b, null)]))), e("div", {
      class: `${t}-date-panel-weekdays`
    }, this.weekdays.map((a) => e("div", {
      key: a,
      class: `${t}-date-panel-weekdays__day`
    }, a))), e("div", {
      class: `${t}-date-panel-dates`
    }, this.dateArray.map((a, l) => e("div", {
      "data-n-date": !0,
      key: l,
      class: [`${t}-date-panel-date`, {
        [`${t}-date-panel-date--current`]: a.isCurrentDate,
        [`${t}-date-panel-date--selected`]: a.selected,
        [`${t}-date-panel-date--excluded`]: !a.inCurrentMonth,
        [`${t}-date-panel-date--disabled`]: this.mergedIsDateDisabled(a.ts, {
          type: "date",
          year: a.dateObject.year,
          month: a.dateObject.month,
          date: a.dateObject.date
        })
      }],
      onClick: () => {
        this.handleDateClick(a);
      }
    }, e("div", {
      class: `${t}-date-panel-date__trigger`
    }), a.dateObject.date, a.isCurrentDate ? e("div", {
      class: `${t}-date-panel-date__sup`
    }) : null)))), this.datePickerSlots.footer ? e("div", {
      class: `${t}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((s = this.actions) === null || s === void 0) && s.length || n ? e("div", {
      class: `${t}-date-panel-actions`
    }, e("div", {
      class: `${t}-date-panel-actions__prefix`
    }, n && Object.keys(n).map((a) => {
      const l = n[a];
      return Array.isArray(l) ? null : e(O, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(l);
        },
        onClick: () => {
          this.handleSingleShortcutClick(l);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => a
      });
    })), e("div", {
      class: `${t}-date-panel-actions__suffix`
    }, !((d = this.actions) === null || d === void 0) && d.includes("clear") ? e(p, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.clearSelectedDateTime
    }, {
      default: () => this.locale.clear
    }) : null, !((c = this.actions) === null || c === void 0) && c.includes("now") ? e(p, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    }) : null, !((h = this.actions) === null || h === void 0) && h.includes("confirm") ? e(p, {
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isDateInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    }) : null)) : null, e(x, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  I as default
};
